var _polygon, _polygon2, _polygon3, _polygon4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    role: "img",
    "aria-label": "PIX",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "12,2 12,12 2,12",
    fill: "#4DD8C8"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "12,2 22,12 12,12",
    fill: "#2DBFAE"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "12,12 22,12 12,22",
    fill: "#1FA898"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "2,12 12,12 12,22",
    fill: "#33C4B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPix);
export default __webpack_public_path__ + "static/media/pix.0afa71666795979c8c12dd18a01bfdf6.svg";
export { ForwardRef as ReactComponent };